import React from 'react';
import { ArrowRight, Instagram, Send } from 'lucide-react';
import { BRAND } from '../mock';

export default function About() {
  return (
    <section id="hikayemiz" className="bg-[#efe6d8] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 border border-stone-300" />
            <img
              src="https://images.unsplash.com/photo-1606259457945-67dc66271ee6?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
              alt="Zarif kumaş dokusu"
              className="relative w-full aspect-[4/5] object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-[11px] tracking-[0.3em] uppercase text-stone-500">Hikâyemiz</p>
          <h2 className="mt-4 font-serif text-4xl lg:text-6xl leading-[1.05] text-stone-900">
            Tesettürü bir <em className="italic font-light">duruş</em>,
            <br />
            zarafeti bir <em className="italic font-light">dil</em> olarak görüyoruz.
          </h2>

          <p className="mt-8 max-w-xl text-[15px] leading-relaxed text-stone-700">
            Leila Tesettür; sade, zamansız ve özenli bir tarz arayan kadınlar için tasarlanmış
            küçük ölçekli bir butiktir. Her bir parçayı kumaşından dikişine kadar titizlikle
            seçer, sınırlı sayıda üretir ve sevgiyle kapınıza ulaştırırız.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-center gap-3 px-6 py-3.5 border border-stone-900 text-stone-900 text-[11px] tracking-[0.24em] uppercase hover:bg-stone-900 hover:text-[#f7f2ec] transition-colors"
            >
              <Instagram className="h-4 w-4" />
              Instagram'da Takip Et
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </div>

      {/* VIP band */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-20">
        <div className="bg-stone-900 text-[#f7f2ec] p-10 lg:p-14 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <p className="text-[11px] tracking-[0.3em] uppercase text-stone-400">VIP Topluluk</p>
            <h3 className="mt-3 font-serif text-3xl lg:text-4xl leading-tight">
              <em className="italic font-light">Özel grubumuza</em> katılın
            </h3>
            <p className="mt-4 max-w-xl text-[14px] text-stone-300 leading-relaxed">
              Yeni koleksiyon duyuruları, üyelere özel indirimler ve sınırlı sayıdaki ürünleri ilk
              siz görmek için WhatsApp topluluğumuza katılın. Spam yok, sadece zarif parçalar.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <a
              href={BRAND.whatsappGroupUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 px-7 py-4 bg-[#f7f2ec] text-stone-900 text-[11px] tracking-[0.24em] uppercase hover:bg-white transition-colors"
            >
              <Send className="h-4 w-4" />
              WhatsApp'a Katıl
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
